import { Box, Text } from "@chakra-ui/react";
import { useEnv } from "../hooks/useEnv";

export default function ProdEnvBanner() {
  const env = useEnv();
  if (env !== "prod") return null;
  return (
    <Box
      bg="red.600"
      color="white"
      px={6}
      py={1.5}
      textAlign="center"
      borderBottomWidth="1px"
      borderBottomColor="red.700"
    >
      <Text fontSize="sm" fontWeight="bold" letterSpacing="wide">
        PRODUCTION — changes affect real customer data
      </Text>
    </Box>
  );
}
